const env = process.env.NODE_ENV || 'development';

const config = {
    development: {
        API_URL: 'http://localhost:5001',
        DEFAULT_TABLE_PROPS: {
            bordered: true,
            size: 'middle'
        }
    },
    production: {
        API_URL: process.env.REACT_APP_BACKEND_API_URL,
        DEFAULT_TABLE_PROPS: {
            bordered: true,
            size: 'middle'
        }
    }
};

export default config[env];